import React, { createContext } from "react";
import { Link } from "react-router-dom";
import useReviews from "../../Hooks/useReviews";
import Resort from "./Sigma.jpg";
import Review from "../Review/Review";

const Home = () => {
  const [reviews, setReviews] = useReviews();

  return (
    <div>
      <div className="container hero-section d-flex gap-5 justify-content-center align-items-center my-5">
        <div className="hero-details">
          <h1>Sigma</h1>
          <h1 className="fs-sm-6">A Digital Creative Agency</h1>
          <p className="mt-5 text-align-left ">
            We were a part of a big software company for some reason we got seperated from that. Later, we thought that we should start our own company.

          </p>
          {" "}
          <Link to="/about" className="btn btn-secondary fw-bold text-light mt-2">
            Book Now
          </Link>
        </div>
        <img src={Resort} alt="" className="img-fluid w-50 rounded" />
      </div>
      <div className="container text-center mt-5 mx-auto row row-cols-2 row-cols-lg-3 g-5  ">
        {reviews.slice(0, 3).map((review) => (
          <Review reviewData={review} key={review.id} />
        ))}
      </div>
      <div className="text-center mb-5">
        <Link to="/reviews" className="btn btn-outline-primary fw-bold">
          All Reviews
        </Link>
      </div>
    </div >
  );
};

export default Home;
